'use client';
import React, { FC } from 'react';
import SearchConatiner from './SearchConatiner';
import { Carousel, CarouselContent, CarouselItem } from '@/src/components/ui/carousel';
import { useLocale, useTranslations } from 'next-intl';
import StoreCard from '../../stores/components/store-card';
import { IStore } from '@/src/types/stores';

type RelatedStoreProps = {
  data: IStore[]; // Adjust type as necessary
  query: string;
};

const RelatedStore: FC<RelatedStoreProps> = ({ data, query }) => {
  const t = useTranslations('search');
  const locale = useLocale();

  return (
    <SearchConatiner title={t('ShopsRelatedTo')} subtitle={query} length={data?.length}>
      <Carousel
        opts={{
          slidesToScroll: 'auto',
          dragFree: true,
          direction: locale === 'ar' ? 'rtl' : 'ltr',
        }}
        className="m-auto w-full self-center lg:h-full"
      >
        <CarouselContent className="ml-0 flex touch-pan-y gap-2.5 py-3 pl-0">
          {data?.map((item) => (
            <CarouselItem
              key={item.id}
              className="xs:flex-[0_0_70%] pl-0 md:flex-[0_0_45%] lg:flex-[0_0_30%]"
              dir={locale === 'ar' ? 'rtl' : 'ltr'}
            >
              <StoreCard storeContent={item} key={item.id} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </SearchConatiner>
  );
};

export default RelatedStore;
